import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createComponentExtension } from '@backstage/core-plugin-api';
import { linguistApiRef } from './api/LinguistApi.esm.js';
import { LinguistClient } from './api/LinguistClient.esm.js';
import { LINGUIST_ANNOTATION } from '@backstage-community/plugin-linguist-common';

const isLinguistAvailable = (entity) => Boolean(entity.metadata.annotations?.[LINGUIST_ANNOTATION]);
const linguistPlugin = createPlugin({
  id: "linguist",
  apis: [
    createApiFactory({
      api: linguistApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ discoveryApi, fetchApi }) => new LinguistClient({ discoveryApi, fetchApi })
    })
  ]
});
const EntityLinguistCard = linguistPlugin.provide(
  createComponentExtension({
    name: "EntityLinguistCard",
    component: {
      lazy: () => import('./components/LinguistCard/index.esm.js').then((m) => m.LinguistCard)
    }
  })
);

export { EntityLinguistCard, isLinguistAvailable, linguistPlugin };
//# sourceMappingURL=plugin.esm.js.map
